import axios from 'axios'
import errorParser from '@/utils/error-parser'

export default {
  /**
   * Fetch current user's name, authorizations
   */
  getClientData () {
    return new Promise((resolve, reject) => {
      axios.get('/client').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },
  signOut () {
    return new Promise((resolve, reject) => {
      axios.post('/client/logout').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },
  passwordForgotten (detail) {
    return new Promise((resolve, reject) => {
      axios.post('/forgotten', detail).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },
  validateToken (detail) {
    return new Promise((resolve, reject) => {
      axios.post('/validatetoken', detail).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },
  updatePassword (detail) {
    return new Promise((resolve, reject) => {
      axios.put('/password/forgotten', detail).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  }
}
